import React from 'react';
import {useAtom} from "jotai";
import {captionItemState, captionListState} from "../../../states/caption";
import {playerState} from "../../../states/player";
import {timestamp2seconds} from "../../../helper/helper";


/**
 플레이어 내 자막 (하단 배치)

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function PlayerCaptionWindow() {

  const [captionList]       = useAtom(captionListState);
  const [{currentCaptionId: currentCaptionIndex}] = useAtom(captionItemState);
  const [{currentTime}]     = useAtom(playerState);

  //const captionItem = captionList.find((c) => currentTime >= timestamp2seconds(c.time_ini) && currentTime < timestamp2seconds(c.time_end));
  const captionListModified = captionList.length > 1 ? captionList.slice(1) : captionList
  // var captionListModified = captionList.shift()!; // theRemovedElement == 1
  const currentCaption = captionListModified.at(currentCaptionIndex-1)?.caption
  const currentCaptionItem = currentTime >= timestamp2seconds(captionListModified[currentCaptionIndex-1].time_ini)
                            && currentTime < timestamp2seconds(captionListModified[currentCaptionIndex-1].time_end)
                            ? true
                            : false
                                                // [currentCaptionIndex-1]?.caption

  return (
    <>
      {
        captionList && currentCaptionItem &&
        <div className="video_caption_area type_align_left">
          <div className="caption">{currentCaption}</div>
          {/* <div className="caption">{captionListModified[currentCaptionId].caption}</div> */}
        </div>
      }
    </>
  );
}
